import { ReloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { appStore } from "src/appStore";
import { workflowStreamsLoader } from "src/business/workflow/apiWorkflow";
import {
  WorkflowStreamsFilter,
  ZWorkflowStream,
} from "src/business/workflow/ZWorkflowStream";
import { onError } from "src/common/onError";
import { MdmTable } from "src/components/MdmTable";
import { PageLayout } from "src/components/PageLayout";
import { RtColumnsSettingsButton } from "src/components/ReactiveTable/components/RtColumnsSettings";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { createWorkflowStreamColumns } from "./workflowStreamColumns";

export const WorkflowStreamsPage: React.FC = observer(() => {
  const columns = React.useMemo(
    () => createWorkflowStreamColumns(!!appStore.isMetadataEditor),
    [appStore.isMetadataEditor],
  );
  const table = React.useMemo(
    () =>
      new RtStore<ZWorkflowStream, WorkflowStreamsFilter>({
        rowKey: "id",
        loader: workflowStreamsLoader(),
        defaultRequest: { pageSize: 20 },
      }),
    [],
  );
  const tools = (
    <>
      <RtColumnsSettingsButton store={table} />
      <Button
        icon={<ReloadOutlined />}
        onClick={() => table.reload().catch(onError)}
      />
    </>
  );
  return (
    <PageLayout title="Рабочие потоки и версии">
      <ToolBox2 extraTools={tools} paddingMode="page">
        <MdmTable
          store={table}
          columns={columns}
          resizableColumns
          rowClick={{
            type: "link",
            builder: (row) => makeUrl(PageUrl.workflowCards, { id: row.id }),
          }}
        />
      </ToolBox2>
    </PageLayout>
  );
});
